exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wizard-icon{color:#8cc63f!important}.active .wizard-icon{color:#fff!important}.wizard-icon-circle{border-color:#8cc63f!important;background-color:#fafaf7!important}.stepTitle{color:#8cc63f!important;margin-top:5px}.form-control{border:1px solid #ced4da!important;background-image:none;border-radius:5px!important;padding:10px}.custom-select{background-color:transparent!important}.wizard-btn{margin-bottom:20px!important}.vue-form-wizard.md .wizard-icon-circle{width:100px;height:100px;border-radius:30px;font-size:24px}.vue-form-wizard .wizard-icon-circle .wizard-icon-container.square_shape{border-radius:20px;padding:32px}.vue-form-wizard.md .wizard-nav-pills>li.active>a .wizard-icon,.vue-form-wizard .wizard-icon-circle .wizard-icon{font-size:34px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-65d59b2b","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/pages/admin/components/forms/investorForm.vue
// module id = 401
// module chunks = 0